'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Predicate2 = require('../abstract/Predicate');

var _Predicate3 = _interopRequireDefault(_Predicate2);

var _ValueSetRegistry = require('../ValueSetRegistry');

var _ValueSetRegistry2 = _interopRequireDefault(_ValueSetRegistry);

var _operators = require('../operators');

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentStatusPredicate = function (_Predicate) {
    (0, _inherits3.default)(DocumentStatusPredicate, _Predicate);

    function DocumentStatusPredicate() {
        (0, _classCallCheck3.default)(this, DocumentStatusPredicate);
        return (0, _possibleConstructorReturn3.default)(this, (DocumentStatusPredicate.__proto__ || (0, _getPrototypeOf2.default)(DocumentStatusPredicate)).apply(this, arguments));
    }

    (0, _createClass3.default)(DocumentStatusPredicate, [{
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            DocumentStatusPredicate.validateValue(this.value);
            return { documentStatus: (0, _operators.getOperatorQueryFragment)(this.operator, this.value, 'small_text') };
        }
    }, {
        key: 'value',
        get: function get() {
            return this.data.value;
        },
        set: function set(value) {
            DocumentStatusPredicate.validateValue(value);
            this.data.value = value;
        }
    }, {
        key: 'operator',
        get: function get() {
            return this.data.operator;
        },
        set: function set(value) {
            this.data.operator = value;
        }
    }], [{
        key: 'validateValue',
        value: function validateValue(value) {
            value = _ValueSetRegistry2.default.evaluate(value);
            if (allowedValues.indexOf(value) === -1 || value instanceof Array && value.some(function (v) {
                return allowedValues.indexOf(v) === -1;
            })) {
                throw new Error('DocumentStatusPredicate: value is incorrect.');
            }
        }
    }]);
    return DocumentStatusPredicate;
}(_Predicate3.default);

var allowedValues = (0, _freeze2.default)(['indexed', 'unindexed']);

DocumentStatusPredicate.defaultData = {
    operator: '$eq',
    value: 'indexed'
};
DocumentStatusPredicate.dataType = 'small_text';
DocumentStatusPredicate.allowedValues = allowedValues;
DocumentStatusPredicate.displayName = 'Document Status';

_QueryNodeRegistry2.default.register(DocumentStatusPredicate);
exports.default = DocumentStatusPredicate;


module.exports.allowedValues = allowedValues;